var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.coachup)?_c('view-coachup',{attrs:{"coachup":_vm.coachup,"show-x":false,"show-print":false,"compact":true}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }